import React, { useContext, useEffect, useState } from 'react';

import EndpointCard from './EndpointCard';
import PbxContext from '../../context/PbxContext';

import { accessLocalStorage } from '../../services';
import { isImpersonatingFromMaster } from '../../services/session';
import { isMasterTenant } from '../../services/tenantScope';
import { REGISTRATION_PHASE0_VALIDATED } from '../../constants/registrationRollout';
import { canViewRegistrations } from './registrationFormat';

import Switch from 'react-bulma-switch/full';

import down from '../../sounds/down.mp3';
import up from '../../sounds/up.mp3';
import './EndpointsList.css';

const isMasterRootSession = (session) =>
  session.user.role === 'root'
  && (isMasterTenant(session.user.idtenant) || isImpersonatingFromMaster(session));

const readRegistrationVisibility = () => {
  const session = accessLocalStorage.getUserLocalStorage();
  if (!session || !session.user) return false;
  return canViewRegistrations(session.user.role, REGISTRATION_PHASE0_VALIDATED, isMasterRootSession(session));
};

const EndpointsList = ({ onOpenRegistration }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { endpoints, ipEndpoints } = getItensStateGlobal;
  const [showOffLine, setShowOffLine] = useState(true);
  const [canViewRegistration] = useState(readRegistrationVisibility);


  const playSoundState = async (state) => {
    const audio = new Audio(state);
    await audio.play();
  }

  const changeStateOfflines = () => {
    if(showOffLine === true) return setShowOffLine(false);
    setShowOffLine(true);
    return;
  };

  const getInitialState  = () => {
    return document.getElementById(ipEndpoints.endpoint);
  };
  
  useEffect(() => {
    getInitialState();
  }, [ipEndpoints, showOffLine]);

    let newEndpoints = endpoints;
    if(!newEndpoints) newEndpoints = [];
    newEndpoints.sort((a, b) => a.resource - b.resource)
    
    return (
      <div className="endpoints-list-container">
        <div className="endpoints-controls">
          <div className="endpoints-info">
            <svg className="info-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Gerencie seus ramais, faça chamadas e transferências</span>
          </div>
          <div className="endpoints-toggle">
            <label className="toggle-label">
              <span className="toggle-text">Mostrar Offline</span>
              <Switch 
                checked={showOffLine} 
                rounded 
                outlined 
                onChange={() => changeStateOfflines()}
              />
            </label>
          </div>
        </div>

        <div className="endpoints-grid">
          {
            newEndpoints.filter((endpoint) => {
              const sizeNameEndpoint = endpoint.resource;
              if(!isNaN(Number(sizeNameEndpoint)) && sizeNameEndpoint.length === 4) {
                return endpoint;
              }
              return null;
            }).map((endpoint) => {
              if(ipEndpoints.endpoint === endpoint.resource) {
                const classNamed = endpoint.state === 'online' ? 'has-background-success' : 'has-background-primary-light';
                endpoint = {
                  technology: endpoint.technology,
                  resource: endpoint.resource,
                  name: endpoint.name,
                  state: endpoint.state,
                  channel_ids: endpoint.channel_ids,
                  myClass: classNamed,
                  ip: ipEndpoints.ip,
                };
              }
              return (
                <EndpointCard
                  key={endpoint.resource}
                  endpoint={endpoint}
                  show={showOffLine}
                  canViewRegistration={canViewRegistration && typeof onOpenRegistration === 'function'}
                  onOpenRegistration={onOpenRegistration}
                />
              );
            })
          }
         </div>
      </div>
    )
};

export default EndpointsList;

